export default __webpack_public_path__ + "static/media/icon-fgts.6ccf3b35.svg";